<template>
    <div class="QualityTest" ref="Box">
        <div class="QualityTestHeader">
            <img src="../../assets/img/left.png" @click="$router.back()" />
            保养实施详情
        </div>
       <!-- <van-tabbar v-model="active" :fixed='false' active-color='#4FA69E'>
            <van-tabbar-item>保养作业报告单</van-tabbar-item>
            <van-tabbar-item>{{this.$route.params.item.TestingName}}报告单</van-tabbar-item>
        </van-tabbar>
        <div v-if="active===0"> -->
            <div class="infoBox quality">
                <van-cell :border='false'>
                    <template>
                        <div class="EquipmentContentClass">
                            <span>资产名称</span>
                            <span>{{this.$route.params.item.EquName}}</span>
                            <span>规格型号</span>
                            <span>{{this.$route.params.item.Standards}}</span>
                        </div>
                    </template>
                </van-cell>
                <van-cell :border='false'>
                    <template>
                        <div class="EquipmentContentClass">
                            <span>序列号</span>
                            <span>{{this.$route.params.item.SBXLH}}</span>
                            <span>资产编号</span>
                            <span>{{this.$route.params.item.EquId}}</span>
                        </div>
                    </template>
                </van-cell>
                <van-cell :border='false'>
                    <template>
                        <div class="EquipmentContentClass">
                            <span>使用科室</span>
                            <span>{{this.$route.params.item.DepName}}</span>
                            <span>维护周期</span>
                            <span>{{this.$route.params.item.KeepCycle}}</span>
                        </div>
                    </template>
                </van-cell>

                <div class="tableTitle">
                   <div>项目名称</div>
                    <div>保养内容</div>
                    <div>保养结果</div>
                </div>
                <div class="tableItems">
                    <div class="tableItemsRightBox">
                        <div v-for="item in list">
                            <div>{{item.JCXMC}}</div>
                            <div>{{item.BZ}}</div>
                            <div>
                                <div :class="item.JCJG==item.ZCJG?'action':''" @click="item.JCJG=item.ZCJG">{{item.ZCJG}}</div>
                                <div :class="item.JCJG==item.YCJG?'action':''" @click="item.JCJG=item.YCJG">{{item.YCJG}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="infoBox quality">
                <div class="tableItems" v-for="item in list2">
                    <div class="tableItemsLeftBox">{{item.title}}</div>
                    <div :class="'tableItemsRightBox2 ' + item.type">
                        <van-checkbox-group v-model="calibration" v-if="item.type === 'checkbox-group'">
                            <van-checkbox v-for="(itemList,index) in item.list" :key="index" :name="index"
                                checked-color="#4fa69e">{{itemList}}</van-checkbox>
                        </van-checkbox-group>
                        <van-radio-group v-model="actuality" v-if="item.type === 'checkbox'">
                            <van-radio v-for="(itemList, index) in item.list" :key="index" :name="index" checked-color="#4fa69e">{{itemList}}</van-radio>
                        </van-radio-group>

                        <div v-if="item.type==='LastRow'">
                            <van-cell>
                                <template>
                                    <div class="OtherContenClass">
                                        <div>
                                            <span>总体评价</span>
                                            <van-radio-group direction="horizontal" v-model="item.explain">
                                                <van-radio name="1" checked-color="#4FA69E">合格</van-radio>
                                                <van-radio name="0" checked-color="#4FA69E">不合格</van-radio>
                                            </van-radio-group>
                                        </div>
                                        <div>
                                            <span>保养费用</span>
                                            <input type='number' v-model='item.InputValue' placeholder='请输入(￥)' />
                                        </div>
                                    </div>
                                </template>
                            </van-cell>
                        </div>

                        <div class="input-group" v-if="item.type === 'input-group'">
                            <div v-for="itemList in item.list">
                                <p>{{itemList.text}}</p>
                                <input type="text" v-if="itemList.type !== 'calender'" placeholder="请输入" v-model="itemList.explain"
                                    :disabled="itemList.disabled ? 'disabled' : false" />
                                <div class="calenderText" v-if="itemList.type === 'calender'" @click="(showCalendar = true,setData = itemList)">{{itemList.explain ? itemList.explain : "请输入"}}</div>
                                <van-calendar :round="false" v-if="itemList.type === 'calender'" v-model="showCalendar"
                                    @confirm="onConfirm" />
                            </div>
                        </div>
                        <input v-if="item.type === 'input'" type="text" :placeholder="item.explain ? item.explain : '请输入'"
                            v-model="item.explain" />
                    </div>
                </div>
            </div>
            <div class="imgBox">
                <ImgModule :disabled='this.$route.params.ButtonExists' :deletable='!this.$route.params.ButtonExists' upload :img="uploadImg" title="图片"
                    @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" />
            </div>
        <div v-if="!this.$route.params.ButtonExists" class="footer" @click="upload">提交</div>
    </div>
</template>

<script>
    import {PresentType} from '../../../config/index.js'
    import ImgModule from '../../components/imgModule/imgModule'
    import {
        Cell,
        Tabbar,
        TabbarItem,
        CheckboxGroup,
        Checkbox,
        RadioGroup,
        Radio,
        Calendar,
        Field,
    } from 'vant'
    export default {
        name: 'MaintainImplementDefault',
        data() {
            return {
                GPDDArray:[{
                    list:[{
                        type:'text',
                        title:'使用科室',
                        rowspan:1,
                        colspan:1,
                    },{
                        type:'input',
                        value:null,
                        rowspan:1,
                        colspan:1,
                        readonly:true
                    },{
                        type:'text',
                        title:'规格型号',
                        rowspan:1,
                        colspan:1,
                    },{
                        type:'input',
                        value:null,
                        rowspan:1,
                        colspan:1
                    }]
                }],
                FSZLArray: [{//放射诊疗设备
                        list: [{
                            width: 16,
                            type: 'text',
                            title: '使用科室'
                        }, {
                            width: 16,
                            type: 'input',
                            value: this.$route.params.item.DepName,
                             readonly:true
                        }, {
                            width: 16,
                            type: 'text',
                            title: '规格型号'
                        }, {
                            width: 16,
                            type: 'input',
                            value: this.$route.params.item.Standards,
                            readonly:true
                        }, {
                            width: 16,
                            type: 'text',
                            title: '联系电话'
                        }, {
                            width: 16,
                            type: 'text',
                            value: this.$route.params.item.Phone,
                            readonly:true
                        }]
                    },
                    {
                        list: [{
                            width: 16,
                            type: 'text',
                            title: '资产名称'
                        }, {
                            width: 16,
                            type: 'input',
                            value: this.$route.params.item.EquName,
                             readonly:true
                        }, {
                            width: 16,
                            type: 'text',
                            title: '资产编号'
                        }, {
                            width: 16,
                            type: 'input',
                            value: this.$route.params.item.EquId,
                             readonly:true
                        }, {
                            width: 16,
                            type: 'text',
                            title: '生产厂家'
                        }, {
                            width: 16,
                            type: 'input',
                            value: this.$route.params.item.Factory,
                             readonly:true
                        }]
                    },{
                        list:[{
                            width:100,
                            type:'text',
                            title:'检测内容'
                        }]
                    },{
                        list:[{
                            width:100,
                            type:'text',
                            title:'1、管电压指示的偏离（观测条件：焦点距探头1m处，光野放至稍大于探头，管电流100mA）'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'预设值kV	'
                        },{
                            width:48,
                            type:'text',
                            title:'测量值kV'
                        },{
                            width:16,
                            type:'text',
                            title:'平均值kV'
                        },{
                            width:16,
                            type:'text',
                            title:'允许误差%'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'70'
                        },{
                            width:16,
                            type:'input',
                            value:null,
                        },{
                            width:16,
                            type:'input',
                            value:null,
                        },{
                            width:16,
                            type:'input',
                            value:null,
                        },{
                            width:16,
                            type:'input',
                            value:null,
                        },{
                            width:16,
                            type:'text',
                            title:'10%',
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'平均偏离%'
                        },{
                            width:64,
                            type:'input',
                            value:null,
                        }]
                    },{
                        list:[{
                            width:100,
                            type:'text',
                            title:'2、输出量（测试条件：管电压70kV，焦点距探头1m处，管电流100mA，时间100ms）'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'测量次数'
                        },{
                            width:16,
                            type:'text',
                            title:'1'
                        },{
                            width:16,
                            type:'text',
                            title:'2'
                        },{
                            width:16,
                            type:'text',
                            title:'3'
                        },{
                            width:16,
                            type:'text',
                            title:'均值'
                        },{
                            width:16,
                            type:'text',
                            title:'≤10mGy'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'测量辐射输出量mGy'
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'text',
                            title:'≤10mGy'
                        }]
                    },{
                        list:[{width:100,type:'text',title:'3、输出重复性（测试条件：管电压70kV，焦点距探头1m处，管电流100mA，时间100ms）'}]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'测量次数I	'
                        },{
                            width:16,
                            type:'text',
                            title:'1'
                        },{
                            width:16,
                            type:'text',
                            title:'2'
                        },{
                            width:16,
                            type:'text',
                            title:'3'
                        },{
                            width:16,
                            type:'text',
                            title:'总次数n'
                        },{
                            width:16,
                            type:'text',
                            title:'允许误差'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'输出量Kn,mGy'
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'input',
                            value:null
                        },{
                            width:16,
                            type:'text',
                            title:'3'
                        },{
                            width:16,
                            type:'text',
                            title:'10%'
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'平均值K,mGy'
                        },{
                            width:64,
                            type:'input',
                            value:null
                        }]
                    },{
                        list:[{
                            width:16,
                            type:'text',
                            title:'输出量的重复性：CV='
                        },{
                            width:64,
                            type:'input',
                            value:null
                        }]
                    },{
                      list:[{width:100,type:'text',title:'4、有用线束半值层（HVL）（测试条件及结果：焦点距探头1m处）'}]
                    },{
                        list:[{width:16,type:'text',title:'管电压Kv'},{width:16,type:'text',title:'管电流mA'},{width:16,type:'text',title:'时间ms'},{width:16,type:'text',title:'半值层mmAL'},{width:16,type:'text',title:'允许误差'}]
                    },{
                        list:[{width:16,type:'text',title:'70'},{width:16,type:'text',title:'100'},{width:16,type:'text',title:'100'},{width:16,type:'input',value:null},{width:16,type:'text',title:'≥2.1'}]
                    }
                ],
                active: 0, //选项卡默认选中
                selectIndex: 0,
                uploadImg: [],
                showCalendar: false,
                data: this.$route.params.item, //基础数据
                list: [], //模板内容  api获取
                list2: [{
                    type: 'LastRow',
                    explain: this.$route.params.item.JCJGALL||"1",
                    InputValue: this.$route.params.item.BYFY,
                }, {
                    title: '其它',
                    list: [{
                        text: '保养人',
                        explain: this.$UserInfo.UserName,
                        disabled: true
                    }, {
                        text: '保养日期',
                        explain: this.$format(new Date(), 'YYYY-MM-DD'),
                        disabled: true
                    }],
                    type: 'input-group'
                }],
                NowDate: this.$format(new Date(), 'YYYY-MM-DD'),
                Model: {
                    JHDH: '',
                    SBBH: '',
                    LRR: '',
                    LRRQ: '',
                    STORE: '',
                    SSR: '',
                    SYNCFLAG: ''
                },
                JCLXArray: ['放射诊疗设备检测报告单', '高频电刀检测报告单', '呼吸机质量检测报告单', '监护仪质量检测报告单'],
            }
        },
        components: {
            ImgModule,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [Calendar.name]: Calendar,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Cell.name]: Cell,
            [Field.name]: Field
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            onConfirm(date) { //  日历
                const _Date =
                    `${date.getFullYear()}-${date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 9 ? '0' + date.getDate() : date.getDate()}`
                this.setData.explain = _Date
                this.showCalendar = false
            },
            upload() { //页面提交
                let data = [];
                this.list.map(x => {
                    data.push({
                        SSDH: this.data.SSDH,
                        XMLX: this.data.MBBH,
                        XMBH: x.JCXBH,
                        XMMC: x.JCXMC,
                        SYNCFLAG: 0,
                        JCJG: x.JCJG,
                    });
                })
                this.$post('api/BY/BYZXJH', {
                    Model: {
                        JCJG:this.list2[0].explain,
                        BYFY:!!this.list2[0].InputValue?this.list2[0].InputValue:'0',
                        SSDH: this.data.SSDH,
                        JHDH: this.data.OrderNo || this.data.JHDH,
                        SBBH: this.data.EquId || this.data.SBBH,
                        STORE: this.$UserInfo.StoreCode,
                        SSKS: this.$UserInfo.DepartmentId,
                        KSBH: this.$UserInfo.DepartmentId,
                        SSR: this.$UserInfo.UserId,
                        SSRQ: this.NowDate,
                        LRR: this.$UserInfo.UserId,
                        LRRQ: this.NowDate,
                        JCRQ: this.NowDate,
                        JCRXM: this.$UserInfo.UserName,
                        JCR: this.$UserInfo.UserId,
                        SYNCFLAG: 0
                    },
                    Deteail: data,
                    STORE: this.$UserInfo.StoreCode,
                    GKHM: this.$UserInfo.UserId
                }).then(result => {
                    if (result.Status) {
                        if (!this.uploadImg.length > 0) {
                            this.$Toast({
                                message:'提交成功!',
                                duration:2000,
                                onClose:()=>{
                                    this.$router.back();
                                    this.$Bus.$emit('Message',this.data);
                                }
                            });
                            return
                        }
                        this.UploadSave(result.Msg);
                    } else this.$Toast('保存失败,请联系管理员!');
                })
            },
            loadDataDefault() { //页面初始加载（双加载)
                if (this.data.SSDH) {
                    this.$get('api/BY/BYYL', { //查询模板
                        JHDH: this.data.JHDH,
                        SBBH: this.data.SBBH,
                        SSDH: this.data.SSDH,
                        MBBH: this.data.MBBH
                    }).then(result => {
                        if (result.Status) {
                            this.list = result.BYXMList;
                            this.$get('api/QualityControl/GetUpImg', {
                                JHDH: this.data.JHDH || this.data.OrderNo,
                                SSDH: this.data.SSDH,
                                LX: "1",
                            }).then(imageResult => {
                                var that = this;
                                imageResult.forEach(function(item, index) {
                                    that.uploadImg.push({
                                        random: that.$getRandomNumber(5),
                                        DABH: item._imagebh,
                                        DAMC: item._imagemc,
                                        DALJ: item._imagelj,
                                        url: item._repath,
                                        JHDH: item._jhdh,
                                        SSDH: item._ssdh,
                                    });
                                });
                            });
                        }
                    });
                } else {
                    this.Model.JHDH = this.data.OrderNo;
                    this.Model.SBBH = this.data.EquId;
                    this.Model.LRR = this.data.ZDR;
                    this.Model.LRRQ = this.data.ZDRQ;
                    this.Model.SSR = this.data.Executor;
                    this.Model.STORE = this.$UserInfo.StoreCode;
                    this.$post('api/BY/BYZXJHCX', { //查询模板
                        Model: this.Model,
                        STORE: this.Model.STORE,
                        SBBH: this.Model.SBBH,
                        SSDH: this.data.SSDH,
                        MBBH: this.data.MBBH,
                        GKHM: this.$UserInfo.UserId
                    }).then(result => {
                        if (result.Status) {
                            this.list = result.data;
                        }
                    });
                }
            },
            afterRead(obj) { //上传图片
                if (obj instanceof Array) {
                    let that = this;
                    obj.forEach(function(item, index) {
                        that.uploadImg.push(item);
                    })
                } else this.uploadImg.push(obj);
            },
            deleteImg(obj) { //删除图片
                if (!obj.content) {
                    this.$Dialog.confirm({
                        message: '是否删除?'
                    }).then(() => {
                        this.$get('api/QualityControl/DeleteAccessory', {
                            JHDH: this.data.JHDH,
                            DABH: obj.DABH,
                            DAMC: obj.DAMC,
                            DALJ: obj.DALJ,
                            LX: "1",
                        }).then(result => {
                            if(result.Status){
                                this.uploadImg.splice(this.uploadImg.findIndex(x => x.random === obj.random), 1);
                                this.$Toast('删除成功!')
                            }else this.$Toast('删除失败!');
                            this.$Toast(result.Msg);
                        });
                    }).catch(() => {});
                }
            },
            UploadSave(SSDH) { //巡检图片上传
                let ImgArray = [];
                this.uploadImg.map(x => {
                    x.content ? ImgArray.push(x.content) : '';
                })
                this.$post('api/QualityControl/PollingAccessoryUpload', {
                    JHDH: this.data.JHDH || this.data.OrderNo,
                    SSDH: SSDH,
                    GKHM: this.$UserInfo.UserId,
                    LX: "1",
                    BaseList: ImgArray
                }).then(result => {
                    if (result.Status) {
                        this.$Toast({
                            message:'保存成功!',
                            duration:2000,
                            onClose:()=>{
                                this.$router.back();
                            }
                        });
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .QualityTest {
        /*transform: rotate(90deg);*/
        /*width: 100vh;*/
        /*min-height: 750px;*/
        background: #F0F4F7;
        /*transform-origin: left top;*/
        /*margin-left: 100%;*/
        padding-bottom: 20px;
        padding-top: 48px;
    }

    .QualityTestHeader {
        width: 100vw;
        height: 48px;
        text-align: center;
        line-height: 48px;
        position: fixed;
        font-size: 18px;
        color: #fff;
        background: $THEME-COLOR;
        top: 0;
        z-index: 10;

        img {
            width: 23px;
            position: absolute;
            left: 2px;
            top: 2px;
            padding: 10px
        }
    }

    .infoBox {
        width: 96%;
        margin: 10px auto;
        padding: 10px 20px;

        .title {
            font-size: 12px;
            margin-bottom: 7px;
        }
    }

    .info {
        display: flex;

        &>div {
            flex: 1;
            text-align: center;
            font-size: 12px;
            color: #999;

            &:first-child {
                flex: 0.35
            }

            p {
                margin-top: 5px;
                margin-bottom: 9px;
                width: 95%;
            }

            span {
                color: $TEXT-DARK-COLOR;
            }

            img {
                width: 50px;
                height: 60px;
                border-radius: 1px;
            }
        }
    }

    .quality {
        padding: 0;
    }

    .tableTitle {
        display: flex;
        height: 33px;
        line-height: 33px;
        border-bottom: 1px solid #e8e8e8;
        font-weight: bold;

        div {
            flex: 1;
            font-size: 12px;
            color: $TEXT-DARK-COLOR;
            text-align: center;

            &:first-child {
                text-indent: -8%;
            }

            // &:last-child {
            //     text-indent: 50%;
            // }
        }
    }

    .tableItems {
        display: flex;
        font-size: 12px;
        color: #333;
        font-weight: bold;

        .tableItemsLeftBox {
            width: 100px;
            border-right: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #e8e8e8;
        }

        &:last-child .tableItemsLeftBox,

        &:last-child .tableItemsRightBox2 {
            border-bottom: none;
        }

        .tableItemsRightBox {
            flex: 1;

            &>div {
                display: flex;
                border-bottom: 1px solid #e8e8e8;

                &>div {
                    //border-bottom: 1px solid #EFEFEF;
                    margin: 20px 0;
                    &:first-child {
                        width: 33% !important;
                        width: 200px;
                        text-align: center;
                    }

                    &:nth-child(2){
                        width: 33% !important;
                        text-align: center;
                    }

                    &:nth-child(3) {
                        width: 34% !important;
                        flex: 0.8;
                        align-items: center;
                        justify-content: center;
                        display: flex;

                        div {
                            width: 80px;
                            height: 25px;
                            background: #F3F3F3;
                            border-radius: 2px;
                            color: #858585;
                            font-size: 8px;
                            line-height: 25px;
                            text-align: center;
                            font-weight: 400;
                            margin-right: 14px;

                            &:last-child {
                                margin-right: 0;
                            }
                        }

                        .action {
                            background: $THEME-COLOR;
                            color: #fff;
                            border-color: rgba(0, 0, 0, 0);
                        }
                    }

                    // &:last-child {
                    //     width: 33% !important;
                    //     flex: 1;
                    //     display: flex;
                    //     justify-content: center;
                    //     align-items: center;

                    //     input {
                    //         width: 115px;
                    //         height: 25px;
                    //         background: #f3f3f3;
                    //         border-radius: 4px;
                    //         font-size: 10px;
                    //         font-weight: 400;
                    //         text-indent: 12px;

                    //         ::-webkit-input-placeholder {
                    //             color: #858585;
                    //         }
                    //     }
                    // }
                }
            }
        }

        .tableItemsRightBox2 {
            flex: 1;
            padding: 10px;
            border-bottom: 1px solid #e8e8e8;

            &>input {
                width: 95%;
                border: 1px solid #e8e8e8;
                margin: auto;
                border-radius: 4px;
                height: 40px;
                background: #f3f3f3;
                font-size: 10px;
                text-indent: 10px;
                font-weight: 400;
            }
        }

        .checkbox-group {
            padding-bottom: 0;

            &>div {
                display: flex;
                flex-wrap: wrap;

                &>div {
                    margin-right: 25px;
                    margin-bottom: 10px;
                }
            }
        }

        .checkbox {
            &>div {
                display: flex;

                &>div {
                    margin-right: 20px;
                }
            }
        }

        .input-group {
            display: flex;

            &>div {
                flex: 1;
                text-align: center;

                input,
                .calenderText {
                    width: 80%;
                    text-align: center;
                    border: 1px solid #e8e8e8;
                    margin: auto;
                    margin-top: 10px;
                    border-radius: 4px;
                    height: 25px;
                    background: #f3f3f3;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 25px;
                    padding: 0;

                    ::-webkit-input-placeholder {
                        color: #858585;
                    }

                    &:disabled {
                        background-color: #f3f3f3;
                        color: $TEXT-DARK-COLOR;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .lastBox {
        padding: 0 10px;

        span {
            color: #F4F4F4 !important;
        }
    }

    .imgBox {
        width: 96%;
        margin: auto;
    }

    .footer {
        width: 96%;
        margin: auto;
        height: 40px;
        background: $THEME-COLOR;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 40px;
        text-align: center;
    }


    .EquipmentContentClass {
        //margin-top: 10px;
        border-bottom: 1px solid #F3F3F3;
        width: 100%;

        span {
            line-height: 24px;
            text-align: center;
            display: inline-block;
            width: 24%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .OtherContenClass {
        &>div {
            &:first-child {
                float: left;
                width: 45%;

                span {
                    width: 25%;
                }

                &>div {
                    float: right;
                    width: 65%;
                }
            }

            &:last-child {
                float: right;
                width: 50%;

                span {
                    width: 25%;
                }

                input {
                    text-align: right;
                }
            }
        }



    }

    .FSZLContent {

        color:#646566;
        &>div {
            height: 26px;
            border: 1px solid #D2D2D2;
            border-bottom: none;
            &:last-child {
                border-bottom: 1px solid #D2D2D2;
            }
        }
        background: #FFFFFF;
        padding: 0;
        margin: 10px  auto;
        .ChildClass {
            border-right: 1px solid #D2D2D2;
            &:last-child {
                border-right: none;
            }
            padding: 0;
            margin: 0;
            height: 26px;
            min-height: 26px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            input{
                text-align: center;
                width: 100%;
            }
        }
    }
    .GPDDContent{
        background: #FFFFFF;
        table{
            margin: 20px auto;
            border-bottom:1px solid #D2D2D2 ;
            td{
                border:1px solid #D2D2D2 ;
                border-bottom: none;
                border-right: none;
                text-align: center;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/page/maintainImplementDefault/maintainImplementDefault.vue